module.exports = __webpack_public_path__ + "img/Coat-of-arms.3cfd3025.png";